import { DeletePopupComponent } from 'src/app/components/delete-popup/delete-popup.component';
import { Component, ElementRef, NgZone, OnInit, SimpleChanges, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { AppGlobals } from 'src/app/app.globals';
import {
  DxFormModule,
  DxSelectBoxModule,
  DxButtonModule,
  DxDataGridModule,
  DxListModule,
  DxPopupModule,
  DxSpeedDialActionModule,
  DxTextBoxModule,
  DxScrollViewModule,
  DxTabPanelModule,
  DxTabsModule,
  DxToastModule,
  DxValidationGroupModule,
  DxTextAreaModule,
  DxValidatorModule,
} from 'devextreme-angular';
import { CommentsComponent } from 'src/app/components/comments/comments.component';
import { GridConnectionService } from 'src/app/services/grid-connection.service';
import { ProjectService } from 'src/app/services/project.service';
import { DataAccessService } from 'src/app/services/data-access.service';

import DataGrid from 'devextreme/ui/data_grid';
import { DashboardService } from 'src/app/services/dashboard.service';
import { SharedPipesModule } from 'src/app/pipes/shared.pipes.module';
import { AppGlobalTranslationDictionary } from 'src/app/app.global-translation-dictionary';
import { environment } from 'src/environments/environment';
import { GenericPopupComponent } from 'src/app/components/generic-popup/generic-popup.component';
import { GlobalPopupService } from 'src/app/components/generic-popup/presets/global-popup/global-popup.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { ConfigService } from 'src/app/services/config.service';
import { ContractSelectorPopupComponent } from "src/app/components/contract-selector-popup/contract-selector-popup.component";
import { FeatureFlags } from 'src/app/interfaces/enums/feature-flag';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { skip, take } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ContractService } from 'src/app/services/contracts/contract.service';
import { ContractSelectorService } from 'src/app/services/contracts/contract-selector.service';
import { SiteContractSelectorPopupComponent } from "src/app/components/site-contract-selector-popup/site-contract-selector-popup.component";
import { GpdButtonComponent } from "src/app/components/gpd-button/gpd-button.component";
import { ActivityLogService } from 'src/app/services/activity-log.service';
import { ActivityEntity, ActivitySection } from 'src/app/constants/activity-log';

import { SearchableDropdownDirective } from '../../../directives/searchable-dropdown.directive';
import { ProjectImagePipe } from 'src/app/pipes/project-image.pipe';
interface MarkerProperties {
  position: {
    lat: number;
    lng: number;
  };
}

@Component({
    selector: 'app-grid-connection-overview',
    imports: [
        CommonModule,
        RouterModule,
        DxValidatorModule,
        DxFormModule,
        DxTextAreaModule,
        DxTabsModule,
        DxValidationGroupModule,
        DxToastModule,
        DeletePopupComponent,
        DxTabPanelModule,
        DxSelectBoxModule,
        DxButtonModule,
        DxDataGridModule,
        DxListModule,
        DxPopupModule,
        DxSpeedDialActionModule,
        DxTextBoxModule,
        DxScrollViewModule,
        SharedPipesModule,
        GpdButtonComponent,
        SearchableDropdownDirective,
        ProjectImagePipe
    ],
    templateUrl: './grid-connection-overview.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./grid-connection-overview.component.css']
})
export class GridConnectionOverviewComponent implements OnInit {
  type: any = '';
  message: any = '';
  toastTwoVisible: boolean = false;

  @ViewChild('cardContainer') cardContainer!: ElementRef;
  @ViewChild('tabGrid') tabGrid;

  saveAddressText: string = $localize`:@@saveAddressCaps:SAVE ADDRESS`;

  phase: any = $localize`:@@phase:Phase:`;
  typeText: any = $localize`:@@type:Type:`;
  sizeOfArea: any = $localize`:@@sizeOfArea:Size of Area:`;
  sizeLabel: any = $localize`:@@sizeColon:Size:`;

  gridConnectionId: any;
  gridConnectionTitle: any;
  gridConnectionNr: any;

  projects: any;
  locations: any;
  locationTypes = [];
  locationsFiltered: any;
  markers: MarkerProperties[] = new Array();

  newLocationId = 0;

  userIsAdmin: boolean = false;
  userCanDeleteSite: boolean = false;
  userCanDeleteProject: boolean = false;

  editMode: boolean = false;
  userCanEdit: boolean = false;

  newLocationTypeMode = false;
  editModeFormData: any;

  newProjectData = {
    nr: null,
    name: null,
    partner: { id: null, name: null, tag: null },
    epc: { id: null, name: null, tag: null },
    phaseId: null,
    areaTypeId: null,
  };

  epcs: any;
  partners: any;

  areaTypes = [$localize`open space`, $localize`roof area`, $localize`floating`];

  phases = [];

  isProcessing = false;

  pvAnlageVisible: boolean = true;
  trafostationVisible: boolean = false;
  ÜGSVisible: boolean = false;

  selectedIndex = 0;
  currentTabGrid: any;

  locationToDelete: any;

  deletePopupVisible: any;
  toastVisible: boolean = false;

  successButtonOptions: any;
  cancelButtonOptions: any;
  copyButtonOptions: any;

  editModeTabGrid: any = false;

  siteData: any = {};

  gridConnectionComments: any = '';
  addAddressVisible: any = false;
  editAddressVisible: any = false;
  addressPopUp: string = $localize`:@@editAddress:Edit Address`;
  selectedLocation: any = {};

  lookUpData: any = new AppGlobalTranslationDictionary();

  countriesByLanguageList: any = [];
  statesByLanguageList: any = [];

  countryStateData: any = [];

  addressItems: any = [];
  addressFocusItem: any = {
    countryId: 2,
  };

  indexToDeleteAddress: any = '';
  locationMapURL: string = '';
  locationHasValidMap: boolean = false;

  pageBreadCrumb: any = { text: $localize`Site Overview/`, href: window.location.href, layer: 0 };

  departments: any;
  isConfigurationIncomplete: boolean = false;

  constructor(
    private dashboardService: DashboardService,
    private gridConnectionService: GridConnectionService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private configService: ConfigService,
    private appGlobals: AppGlobals,
    private globalPopupService: GlobalPopupService,
    private dataAccessService: DataAccessService,
    private activityLog: ActivityLogService
  ) {
    this.userCanEdit = AppGlobals.UserPermissions.canEdit;
    let that = this;
    this.userIsAdmin = AppGlobals.UserPermissions.isAdministrator;

    this.userCanDeleteSite = AppGlobals.UserPermissions.canDelete;
    this.userCanDeleteProject = AppGlobals.UserPermissions.canDelete;

  }

  ngOnInit(): void {

    this.gridConnectionId = this.activatedRoute.snapshot.params.id;
    this.logSiteView();
    this.getPageData();
    this.getSiteOverview();

    if (AppGlobals.breadCrumbs[AppGlobals.breadCrumbs.length - 1].layer === 1) AppGlobals.breadCrumbs.pop();

    this.getCountriesByLanguage();
    this.getStatesByLanguage(2);

    this.configService.getProjectConfigStatus({}).then(configStatus => {  
      if (configStatus.hasError) {
        AppGlobals.ShowErrorMessage(configStatus.feedback);
        return;
      }
      this.isConfigurationIncomplete = !configStatus.hasProjectConfiguration || !configStatus.hasAreaTypes;
    }, error => {
      AppGlobals.ShowErrorMessage(error);
    });

    this.dataAccessService.loadDepartments().then(result => {
        this.departments = result;
    });
  }

  private logSiteView(): void {
    const siteId = Number(this.gridConnectionId);
    if (!siteId) return;
    this.activityLog.logView({
      Section: ActivitySection.SITE,
      EntityType: ActivityEntity.SITE,
      EntityId: siteId,
      SiteId: siteId,
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.newProjectData) {
    }
  }

  getPageData() {
    //get user permissions because epcs and partners are defined in this table
    this.dashboardService.getEpcList({}).then(
      result => {
        if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
        else {
          this.epcs = result.companyList;
        }
      },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );

    this.dashboardService.getPartnerList({}).then(
      result => {
        if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
        else {
          this.partners = result.companyList;
        }
      },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );

    this.gridConnectionService.getGridConnectionTitle({ GridConnectionId: this.gridConnectionId }).then(
      result => {
        if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
        else {
          this.gridConnectionTitle = result.gridConnectionTitleItem.title;
          this.gridConnectionNr = result.gridConnectionTitleItem.nr;
          this.newProjectData.name = result.gridConnectionTitleItem.title;
        }
      },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );

    this.gridConnectionService
      .getProjectsByGridConnectionId({
        requestItem: { GridConnectionId: this.gridConnectionId },
      })
      .then(
        result => {
          if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
          else {
            this.projects = result.projectCardItems;
          }
        },
        (error: any) => {
          AppGlobals.ShowErrorMessage(error);
        }
      );
    

  }

  loadLocationMap(locationData: any): void {
    this.locationHasValidMap = false;
    this.locationMapURL = '';

    if (locationData == null) return;
    if (locationData.latitude == null || locationData.longitude == null) return;
    if (locationData.latitude == '' || locationData.longitude == '') return;

    this.locationHasValidMap = true;
    this.locationMapURL = `https://maps.google.com/maps?q=${locationData.latitude},${locationData.longitude}&z=8&output=embed`;
  }

  getLocationName(item) {
    let locationName;
    try {
      locationName = this.locationTypes.find(location => location.id == item.locationTypeId).name;
    } catch (e) {
      locationName = item.name;
    }
    return locationName;
  }

  goToProject(id) {
    this.router.navigate([`site/${this.gridConnectionId}/project/${id}/projectInfo/overview`]);
    this.pageBreadCrumb = { text: $localize`Site Overview/`, href: window.location.href, layer: 1 };

    AppGlobals.setBreadCrumbToLocalStorage(this.pageBreadCrumb);
  }

  saveToast(e: any): void {
    const type = e.type ? 'success' : 'error';
    if ((this.type = 'success')) {
      this.message = e.feedback;
    } else {
      AppGlobals.ShowErrorMessage($localize`:@@errorTryAgain:ERROR: There was an error, please try again.`);
    }
    this.type = type;
    this.toastTwoVisible = true;
  }

  getLocationTypes() {
    return this.locationTypes.filter(lt => !lt.hasOwnProperty('used'));
  }

  checkLocationsForMissingInfo(data) {
    for (const [key, value] of Object.entries(data)) {
      if (key != 'notes' && (value == null || value == '')) {
        return false;
      }
    }
    return true;
  }

  selectedIndexChanged(e) {
    this.selectedIndex = e;
    this.filterLocations(e);
  }

  async filterLocations(e: any) {
    for (let i = 0; i < this.locations.length; i++) {
      if (this.locations[i].locationTypeId === e) {
        this.locationsFiltered = this.locations[i].locationAddresses;
        this.translateCountryNames();
        // The map must show an address the user can actually see in the grid,
        // so seed it from the list on screen. Selecting a row overrides this
        // via jumpToLocation.
        this.loadLocationMap(
          this.locationsFiltered.find((loc: any) => loc.latitude && loc.longitude)
        );
      }
    }
  }

  translateCountryNames(): void {
    this.locationsFiltered.forEach((loc: any) => {
      this.lookUpData.CountryData.forEach((c: any) => {
        if (loc.countryId === c.id) {
          loc.country = c.text;
          c.states.forEach((s: any) => {
            if (loc.stateId == s.id) loc.state = s.text;
          });
        }
      });
    });
  }

  getNewLocationId() {
    this.newLocationId -= 1;
    return this.newLocationId;
  }

  initNewRow(e) {
    e.data['id'] = this.getNewLocationId();
    e.data['gridConnectionId'] = Number(this.gridConnectionId);
    // selectedIndex already holds the selected location type id (set from the tab
    // click / default), so use it directly — consistent with saveSiteLocation.
    e.data['locationTypeId'] = this.selectedIndex;
  }

  onRowInserted(e) {
    this.locations.push(e.data);
    this.loadLocationMap(e.data);
  }

  initDeleteLocation(item, index) {
    this.indexToDeleteAddress = index;
    this.locationToDelete = item;
    this.deletePopupVisible = true;
  }

  onDeleteAbort(e: any) {
    this.deletePopupVisible = false;
    this.locationToDelete = null;
  }

  handleDelete(e: any): void {
    this.gridConnectionService
      .removeGridConnectionLocation({ GridConnectionLocationId: this.locationToDelete.id })
      .then(
        result => {
          if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
          else {
            this.getPageData();
            this.getSiteOverview();
            this.deletePopupVisible = false;
            this.locationToDelete = null;
          }
        },
        (error: any) => {
          AppGlobals.ShowErrorMessage(error);
        }
      );
    /*
    for (let i = 0; i < this.locations.length; i++) {
      if (this.locations[i].locationTypeId === this.selectedIndex) {
        this.locations[i].locationAddresses.splice(this.indexToDeleteAddress, 1);
      }
    }

    this.deletePopupVisible = false;

      if (this.locationToDelete.id < 0) {
       let itemToDeleteIndex = this.locations.findIndex(item => item.id == this.locationToDelete.id)
       this.locations.splice(itemToDeleteIndex, 1);
       //  this.filterLocations();
     }
     else {
       this.gridConnectionService.deleteGridConnectionLocation({ DeleteGridConnectionLocationRequestItem: this.locationToDelete }).then((result) => {
         if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
         else {
           this.saveToast({ type: true, feedback: `Deleted` });
           let itemToDeleteIndex = this.locations.findIndex(item => item.id == this.locationToDelete.id)
           this.locations.splice(itemToDeleteIndex, 1);
           //  this.filterLocations();
         }
       },
         (error: any) => {
           AppGlobals.ShowErrorMessage(error);
         });
     }  
     */
  }

  editLocation(target, rowIndex) {
    this.selectedLocation = target;

    this.addressPopUp = $localize`:@@editAddress:Edit Address`;
    this.editAddressVisible = true;

    this.newCountryLoaded = true;

    this.countryStateData = this.lookUpData.CountryData.filter(item => {
      return item.id === this.selectedLocation.countryId;
    })[0]?.states;
    this.getCountriesByLanguage();
    this.getStatesByLanguage(target.countryId);
  }

  newCountryLoaded: boolean = false;

  addLocation() {
    this.countryStateData = this.lookUpData.CountryData[0].states;

    this.addressPopUp = $localize`:@@addAddress:Add Address`;
    this.editAddressVisible = true;
    this.addAddressVisible = true;
    this.selectedLocation = {
      address: '',
      city: '',
      zipcode: '',
      country: this.lookUpData.CountryData[0].value,
      state: this.countryStateData[0].value,
      longitude: '',
      latitude: '',
      notes: '',
    };

    this.newCountryLoaded = true;
  }

  handleCountryChange(e: any): void {
    this.getStatesByLanguage(e);
    /*
    if (this.newCountryLoaded === true) {
      this.newCountryLoaded = false;
      return;
    }
    */

    /*     if (this.selectedLocation.countryId == null) {
          this.selectedLocation.countryId = this.lookUpData.CountryData[0].id;
        }
    
        this.countryStateData = this.lookUpData.CountryData.filter((item) => { return item.id === this.selectedLocation.countryId })[0]?.states;
    
        if (this.countryStateData == null) this.countryStateData = [];
    
    
        let newStateId = null;
        if (this.countryStateData.length !== 0) newStateId = this.countryStateData[0].id;
    
    
        if (this.selectedLocation.stateId != null) {
          this.countryStateData.forEach((s: any) => {
            if (s.id == this.selectedLocation.stateId) newStateId = this.selectedLocation.stateId;
          });
        }
    
        this.selectedLocation.stateId = newStateId; */
  }

  jumpToLocation(e) {
    if (e == null) return;
    if (e.selectedRowsData == null) return;
    if (e.selectedRowsData.length == 0) return;
    let rowData = e.selectedRowsData[0];

    this.loadLocationMap({ latitude: rowData.latitude, longitude: rowData.longitude });
  }

  addComment(e: any): void {}

  cancelEditMode(): void {
    this.editMode = false;
  }

  enableEditMode(): void {
    this.editMode = true;
  }

  getSiteOverview(): void {
    this.gridConnectionService.getSiteOverview({ GridConnectionId: this.gridConnectionId }).then(
      result => {
        if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
        else {
          this.gridConnectionTitle = result.siteOverview.siteName;
          this.gridConnectionNr = result.siteOverview.siteNr;
          this.newProjectData.name = result.siteOverview.siteName;
          this.areaTypes = result.siteOverview.areaTypes;
          this.phases = result.siteOverview.phases;

          this.siteData = {
            projectName: result.siteOverview.siteName,
            projectNumber: result.siteOverview.siteNr,
            projectPipelineNumber: result.siteOverview.sitePipelineNr,
            comments: result.siteOverview.comments,
          };

          this.locationTypes = [];

          for (let i = 0; i < result.siteOverview.siteLocations.length; i++) {
            this.locationTypes.push(result.siteOverview.siteLocations[i]);
          }

          this.locations = result.siteOverview.siteLocations;

          // Default to the first actual location type rather than a hardcoded id,
          // so a new location is always saved against a type that exists in the DB.
          const defaultLocationTypeId = this.locationTypes[0]?.locationTypeId;
          if (defaultLocationTypeId != null) {
            this.selectedIndexChanged(defaultLocationTypeId);
          }
        }
      },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );
  }

  goTo(path: any) {
    this.router.navigate([path]);
    AppGlobals.setBreadCrumbToLocalStorage(this.pageBreadCrumb);
  }

  saveSiteData(): void {

    let siteData = {
      siteOverview: {
        siteId: this.gridConnectionId,
        siteName: this.siteData.projectName,
        siteNr: this.siteData.projectNumber,
        sitePipelineNr: this.siteData.projectPipelineNumber,
        comments: this.siteData.comments,
        siteLocations: this.locations,
      },
    };

    this.gridConnectionService.writeSiteOverview(siteData).then(
      result => {
        if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
        else {
          this.addAddressVisible = false;
          this.editAddressVisible = false;
          this.saveToast({ type: true, feedback: $localize`:@@saved:Saved` });
          this.refreshPageData();
          this.editMode = false;
        }
      },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );
  }

  refreshPageData(): void {
    this.getSiteOverview();
  }

  saveSiteLocation(e: any): void {
    e.preventDefault();

    let payload = {
      ...this.selectedLocation,
      gridConnectionId: parseInt(this.gridConnectionId),
      locationTypeId: this.selectedIndex,
    };

    if (payload['id'] == null || payload['id'] == undefined) {
      payload['id'] = this.getNewLocationId();
    }

    this.gridConnectionService.saveGridConnectionLocation({ SaveRequestItem: payload }).then(
      result => {
        if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
        else {
          this.addAddressVisible = false;
          this.editAddressVisible = false;
          this.saveToast({ type: true, feedback: $localize`:@@saved:Saved` });
          this.refreshPageData();
        }
      },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );
  }

  resetForm() {
    this.selectedLocation = {}; // Reset form data
    this.selectedLocation.instance.reset(); // Reset form fields and validation
  }

  initSiteLocationDeletion(target, rowIndex) {}

  // Remove site/project

  removeSiteFolderMessage: string = $localize`Do you want to remove all folders and files associated with this Site? If you choose to keep these folders/files, they will be automatically associated to any future sites that share the same name as the site you are removing.`;

  removeProjectFolderMessage: string = $localize`Do you want to remove all folders and files associated with this Project?`;

  deleteSitePopupVisible: boolean = false;
  deleteSiteFolderPopupVisible: boolean = false;
  siteToDelete: any = {};

  initDeleteSite(): void {
    //this.siteToDelete = item;
    this.deleteSitePopupVisible = true;
    this.deleteSiteFolderPopupVisible = false;
  }

  handleDeleteSiteShowFolders(e: any): void {
    this.deleteSitePopupVisible = false;
    this.deleteSiteFolderPopupVisible = true;
  }

  handleKeepSiteFolders(): void {
    this.handleDeleteSite(false);
  }

  handleRemoveSiteFolders(): void {
    this.handleDeleteSite(true);
  }

  handleDeleteSite(deleteFiles: boolean): void {
    let payload = {
      GridConnectionId: parseInt(this.gridConnectionId),
      DeleteRelatedFiles: deleteFiles,
    };

    this.gridConnectionService.deleteGridConnection(payload).then(
      result => {
        if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
        else {
          this.goTo('grid-connections');
        }
      },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );
  }

  deleteProjectPopupVisible: boolean = false;
  deleteProjectFolderPopupVisible: boolean = false;
  projectToDeleteId: number = 0;

  initDeleteProject(project: any, e: any): void {
    this.projectToDeleteId = project.id;
    e.stopPropagation();

    this.deleteProjectPopupVisible = true;
    this.deleteProjectFolderPopupVisible = false;
  }

  handleDeleteProjectShowFolders(e: any): void {
    this.deleteProjectPopupVisible = false;
    this.deleteProjectFolderPopupVisible = true;
  }

  handleKeepProjectFolders(): void {
    this.handleDeleteProject(false);
  }

  handleRemoveProjectFolders(): void {
    this.handleDeleteProject(true);
  }

  handleDeleteProject(deleteFiles: boolean): void {
    let payload = {
      DeleteProjectItem: {
        ProjectId: this.projectToDeleteId,
        DeleteRelatedFiles: deleteFiles,
      },
    };

    this.gridConnectionService.deleteProject(payload).then(
      result => {
        if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
        else {
          this.deleteProjectPopupVisible = false;
          this.deleteProjectFolderPopupVisible = false;
          this.getPageData();
        }
      },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );
  }

  getCountriesByLanguage(): void {
    this.gridConnectionService.getCountries({}).then(
      result => {
        if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
        else {
          this.countriesByLanguageList = result.countryList;
        }
      },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );
  }

  getStatesByLanguage(countryID: any): void {
    let selectedCountry = { CountryId: countryID };

    this.gridConnectionService.getStates(selectedCountry).then(
      result => {
        if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
        else {
          this.statesByLanguageList = result.stateList;
        }
      },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );
  }

  async initNewProject(event: Event) {
    try {
      // Check configuration status


      // Check if configuration is valid
      if (this.isConfigurationIncomplete) {
        this.globalPopupService.showPopup({
          title: $localize`:@@configurationIncomplete:Configuration Incomplete`,
          content: $localize`:@@configurationIncompleteMessage:The project configuration is incomplete. Please complete the configuration before creating a project.`,
          buttons: [
            {
              text: $localize`:@@ok:Ok`,
              onClick: () => {},
              type: 'secondary',
            },
            {
              text: $localize`:@@goToConfiguration:Go to Configuration`,
              type: 'primary',
              onClick: () => {
                this.router.navigate(['/config/project-config']);
              },
            },
          ],
        });
        return;
      }

      // Check if departments exist

      if (this.departments?.length == 0) {
        this.globalPopupService.showPopup({
          title: $localize`:@@noDepartments:No Departments`,
          content: $localize`:@@noDepartmentsMessage:There are no departments defined. Please add departments before creating a project.`,
          buttons: [
            {
              text: $localize`:@@ok:Ok`,
              onClick: () => {},
              type: 'primary',
            },
          ],
        });
        return;
      }

      // All checks passed, navigate to project creation page
      this.router.navigate([`/site/${this.gridConnectionId}/create-project`]);
    } catch (error) {
      AppGlobals.ShowErrorMessage(error);
    }
  }
}
